import {HandbookEditAPI} from "../../api/api.js";

const SET_START_LOADING = 'handbookEditReducer/SET_START_LOADING'
const SET_STOP_LOADING = 'handbookEditReducer/SET_STOP_LOADING'
const SET_REFERENCE_DESCRIPTIONS = 'handbookEditReducer/SET_REFERENCE_DESCRIPTIONS'

const initialState = {
    loading: false,
    referenceDescriptions: []
}

export const handbookEditReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_START_LOADING:
            return {
                ...state,
                loading: true
            }

        case SET_REFERENCE_DESCRIPTIONS:
            return {
                ...state,
                referenceDescriptions: action.referenceDescriptions.map(
                    (el, index) => ({...el, sequenceNumber: index + 1})
                )
            }

        default:
            return state
    }
}


export const startLoading = () => ({type: SET_START_LOADING})
export const stopLoading = () => ({type: SET_STOP_LOADING})
export const selectLoading = (state) => state.handbookEditReducer.loading

export const setReferenceDescriptions = (referenceDescriptions) => ({
    type: SET_REFERENCE_DESCRIPTIONS,
    referenceDescriptions
})
export const selectReferenceDescriptions = (state) => state.handbookEditReducer.referenceDescriptions


export const getReferenceDescriptions = (handbookID) => async (dispatch) => {
    const response = await HandbookEditAPI.getReferenceDescriptions(handbookID)
    await dispatch(setReferenceDescriptions(response.data))
}

export const createReferenceDescription = (values) => async () => {
    await HandbookEditAPI.createReferenceDescriptions(values)
}

export const deleteReferenceDescriptions = (referenceDescriptionIDs) => async () => {
    for (const id of referenceDescriptionIDs) {
        await HandbookEditAPI.deleteReferenceDescriptions(id)
    }
}